
export const LOGIN_VERBIAGE = 'Merchant Portal is a platform that allows you to access, view, and analyze important business metrics and data. This platform will be a way for merchants to update their business, view real time store statistics, and download reports, which all help to grow their business.';
export const LOGIN_SUB_TEXT = 'If you do not have an account yet, click on Get Started and follow the steps to sign up for an account.'
export const EMAIL_VERBIAGE = 'If you do not yet have an account, please contact us at [email] and provide the following details:';
export const LOCATION_LIST = 'Location list';
export const TEMP_PASSWORD_TEXT = 'Please create a new password to start using Merchant Portal.';
export const DELIVERY_TIME = 'Current order delivery time';
export const LAUNCH_TIME = 'Desired launch date';
export const IMAGES = 'Images/Assets';
export const INITIAL_MODEL_CONTENT = {
    HEADER_LEFT: 'Add Order Platform',
    HEADER_RIGHT: '| 7NOW Marketplace',
    CLAUSE_ONE : 'Become a merchant on 7NOW Marketplace to gain access to millions of loyal 7 Eleven convenience customers while exposing your business to customers you never had access to!',
    CLAUSE_TWO : 'Steps for integration: Upon clicking “Continue” below, you will be guided to reach out to our 7NOW team via [email pending] to begin the integration process.',
    CLAUSE_THREE: 'Please include the following in your email and a 7NOW representative will get back to you within 3 business days:'
};
export const RESTRICT_MODEL = {
    HEADER_LEFT: 'Restricted',
    HEADER_RIGHT: '| 7NOW Marketplace',
    CLAUSE_ONE : 'You dont have the access granted by the Admin, to visit this section',
    CLAUSE_TWO : 'Please contact Admin or support for any query or concerns',
    CLAUSE_THREE: '',
    BUTTON_TEXT: 'Close'
};
export const LOCATION_MODEL_CONTENT = {
    TITLE: 'Location',
    TITLE_ONE:'Existing Locations',
    CLAUSE_ONE: 'Please confirm that your 7NOW location matches the ItsaCheckmate location. If you have multiple locations listed, please select your 7NOW location that matches the ItsaCheckmate location and click the Connect button.',
    CLAUSE_TWO: 'If any information is incorrect, please click Close and verify that you are using the right login credentials or contact us.',
    ADDRESS_TITLE: '7NOW Merchant Location',
    SEVEN_NOW_NAME: 'Name : 7NOW Merchant',
    SEVEN_NOW_ADDRESS: 'Address: 3200 Hackberry Rd, Irving, TX 71309',
    MERCHANT_TITLE: 'ItsaCheckmate Location',
    ID: 'ID:',
    NAME: 'NAME:',
    ADDRESS: 'ADDRESS:',
    POS: 'POS:'
};
export const REDIRECT_CONNECT_POPOVER = {
	REQUEST_TO_UPDATE_STORE: 'Request to Update Store',
	CLAUSE_THREE: 'In order to update a store, you must request access to the Otter platform. You will be redirected to the login page to enter your credentials and continue with the flow.',
    TITLE: 'Authentication Connect',
    TITLE_ONE:'Otter Connect',
    CLAUSE_ONE: 'Clicking on Connect will redirect you for further proceedings',
    CLAUSE_TWO: 'Clicking on Connect will redirect you to Otter Portal for Integration access for further proceedings',
    ADDRESS_TITLE: '',
    SEVEN_NOW_NAME: '',
    SEVEN_NOW_ADDRESS: '',
    MERCHANT_TITLE: '',
    ID: '',
    NAME: '',
    ADDRESS: '',
    POS: ''
};
export const ACTIVATION_POPOVER = {
	ACTIVATE_TITLE: 'Activate Store',
	DEACTIVATE_TITLE: 'Deactivate Store',
	CONFIRM_ACTIVATION: 'Are you sure you want to activate the selected store?',
	CONFIRM_DEACTIVATION: 'Are you sure you want to deactivate the selected store?'
};
export const LIST_OF_ACCOUNT_CREATION =  ['Current delivery volume', 'List of locations', 'Desired start date', 'Images/Assets'];
export const OTP_VERBIAGE = 'An email will be sent for you to reset your password.';
